import React from 'react'
import DashboardNavbar from '../components/navbar/dashboard-navbar'

export default function DashboardNavbarView() {
  return <DashboardNavbar />
}
